import { render, staticRenderFns } from "./DriverDocumentList.vue?vue&type=template&id=15394a11&"
import script from "./DriverDocumentList.vue?vue&type=script&lang=js&"
export * from "./DriverDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports